import {useCallback} from "react";
import {css} from "@panda/css";

import {GTMEventApplicationSourceSection} from "../../../application/types/lead/GTMEvenApplicationSourceSection";
import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {UnlockChoiceEntryPoint} from "../../../auth/types/UnlockChoiceEntryPoint";
import {useFavourites} from "../../../favorite/hooks/use_favourites";
import {Offer3dView} from "../../constants/offer_3d_views";
import {useContentRegistrationGateActions} from "../../hooks/use_content_registration_gate_actions";
import {hasOffer3dView} from "../../utils/has_offer_3d_view";
import {ContentRegistrationGate} from "../ContentRegistrationGate";

interface Props {
    propertyId?: number;
    offerId?: number;
    photosAvailable?: boolean;
    construction3dTours?: Offer3dView[] | null;
    needsPhoneVerification?: boolean;
}

export const ConstructionGalleryPaywallTrigger = (props: Props) => {
    const {propertyId, offerId, photosAvailable = false, construction3dTours, needsPhoneVerification = false} = props;
    const {
        addOfferToFavouritesWithoutAuthCheck,
        addPropertyToFavouritesWithoutAuthCheck,
        isOfferInFavourites,
        isPropertyInFavourites,
        favouritePropertiesIds,
        favouriteOfferIds
    } = useFavourites();

    const onRegistrationSuccess = useCallback(async () => {
        if (offerId && propertyId && !photosAvailable && !isPropertyInFavourites(propertyId)) {
            await addPropertyToFavouritesWithoutAuthCheck(propertyId, offerId, false, true);
            return;
        }
        if (offerId && !photosAvailable && !isOfferInFavourites(offerId)) {
            await addOfferToFavouritesWithoutAuthCheck(offerId, true);
        }
    }, [favouriteOfferIds, favouritePropertiesIds]);

    const {onRegister, onLogin, onPhoneVerification} = useContentRegistrationGateActions({
        gtmSourceSection: GTMEventApplicationSourceSection.MODAL_CONSTRUCTION_GALLERY,
        titleVariant: AuthModalVariant.CONSTRUCTION_PHOTOS,
        amplitudePlacement: "rp_construction_photos",
        unlockChoiceEntryPoint: UnlockChoiceEntryPoint.CONSTRUCTION_PHOTOS,
        offerId,
        propertyId,
        registrationSuccessCallback: onRegistrationSuccess
    });

    const getTitle = () => {
        if (needsPhoneVerification) {
            return "Zweryfikuj numer telefonu, aby otrzymać dostęp do zdjęć z budowy";
        }

        return hasOffer3dView({id: offerId}, construction3dTours)
            ? "Załóż konto, aby otrzymać dostęp do zdjęć z budowy i widoku 3D"
            : "Wszystkie zdjęcia z budowy dostępne są dla zalogowanych użytkowników";
    };

    return (
        <>
            <div className={overlayStyle} />
            <div className={triggerPlacement}>
                <ContentRegistrationGate
                    title={getTitle()}
                    onRegister={onRegister}
                    onLogin={onLogin}
                    onPhoneVerification={needsPhoneVerification ? onPhoneVerification : undefined}
                />
            </div>
        </>
    );
};

const overlayStyle = css({
    width: "100%",
    height: "100%",
    position: "absolute",
    inset: 0,
    zIndex: 1
});

const triggerPlacement = css({
    width: "100%",
    height: "calc(100vh - var(--globals-baseUnit) * 8 - var(--globals-baseUnit) * 12)",
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    position: "absolute",
    inset: 0,
    zIndex: 2,
    py: 5.5,
    overflow: "auto",

    md: {
        alignItems: "center",
        height: "calc(100vh - var(--globals-baseUnit) * 12)"
    }
});
import {useCallback} from "react";
import {css} from "@panda/css";

import {GTMEventApplicationSourceSection} from "../../../application/types/lead/GTMEvenApplicationSourceSection";
import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {UnlockChoiceEntryPoint} from "../../../auth/types/UnlockChoiceEntryPoint";
import {useFavourites} from "../../../favorite/hooks/use_favourites";
import {Offer3dView} from "../../constants/offer_3d_views";
import {useContentRegistrationGateActions} from "../../hooks/use_content_registration_gate_actions";
import {hasOffer3dView} from "../../utils/has_offer_3d_view";
import {ContentRegistrationGate} from "../ContentRegistrationGate";

interface Props {
    propertyId?: number;
    offerId?: number;
    photosAvailable?: boolean;
    construction3dTours?: Offer3dView[] | null;
    needsPhoneVerification?: boolean;
}

export const ConstructionGalleryPaywallTrigger = (props: Props) => {
    const {propertyId, offerId, photosAvailable = false, construction3dTours, needsPhoneVerification = false} = props;
    const {
        addOfferToFavouritesWithoutAuthCheck,
        addPropertyToFavouritesWithoutAuthCheck,
        isOfferInFavourites,
        isPropertyInFavourites,
        favouritePropertiesIds,
        favouriteOfferIds
    } = useFavourites();

    const onRegistrationSuccess = useCallback(async () => {
        if (offerId && propertyId && !photosAvailable && !isPropertyInFavourites(propertyId)) {
            await addPropertyToFavouritesWithoutAuthCheck(propertyId, offerId, false, true);
            return;
        }
        if (offerId && !photosAvailable && !isOfferInFavourites(offerId)) {
            await addOfferToFavouritesWithoutAuthCheck(offerId, true);
        }
    }, [favouriteOfferIds, favouritePropertiesIds]);

    const {onRegister, onLogin, onPhoneVerification} = useContentRegistrationGateActions({
        gtmSourceSection: GTMEventApplicationSourceSection.MODAL_CONSTRUCTION_GALLERY,
        titleVariant: AuthModalVariant.CONSTRUCTION_PHOTOS,
        amplitudePlacement: "rp_construction_photos",
        unlockChoiceEntryPoint: UnlockChoiceEntryPoint.CONSTRUCTION_PHOTOS,
        offerId,
        propertyId,
        registrationSuccessCallback: onRegistrationSuccess
    });

    const getTitle = () => {
        if (needsPhoneVerification) {
            return "Zweryfikuj numer telefonu, aby otrzymać dostęp do zdjęć z budowy";
        }

        return hasOffer3dView({id: offerId}, construction3dTours)
            ? "Załóż konto, aby otrzymać dostęp do zdjęć z budowy i widoku 3D"
            : "Wszystkie zdjęcia z budowy dostępne są dla zalogowanych użytkowników";
    };

    return (
        <>
            <div className={overlayStyle} />
            <div className={triggerPlacement}>
                <ContentRegistrationGate
                    title={getTitle()}
                    onRegister={onRegister}
                    onLogin={onLogin}
                    onPhoneVerification={needsPhoneVerification ? onPhoneVerification : undefined}
                />
            </div>
        </>
    );
};

const overlayStyle = css({
    width: "100%",
    height: "100%",
    position: "absolute",
    inset: 0,
    zIndex: 1
});

const triggerPlacement = css({
    width: "100%",
    height: "calc(100vh - var(--globals-baseUnit) * 8 - var(--globals-baseUnit) * 12)",
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    position: "absolute",
    inset: 0,
    zIndex: 2,
    py: 5.5,
    overflow: "auto",

    md: {
        alignItems: "center",
        height: "calc(100vh - var(--globals-baseUnit) * 12)"
    }
});
